import React from 'react';

import { cssMap } from '@atlaskit/css';
import LiveDocIcon from '@atlaskit/icon-lab/core/page-live-doc';
import DatabaseIcon from '@atlaskit/icon/core/database';
import FolderIcon from '@atlaskit/icon/core/folder-closed';
import EmbedIcon from '@atlaskit/icon/core/link';
import PageIcon from '@atlaskit/icon/core/page';
import BlogPostIcon from '@atlaskit/icon/core/quotation-mark';
import WhiteboardIcon from '@atlaskit/icon/core/whiteboard';
import Image from '@atlaskit/image';
import { Inline } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import type { ConfluenceContentType } from '../base-page-selector/types';

const styles = cssMap({
	spaceIcon: {
		flexShrink: 0,
		borderWidth: 0,
		backgroundColor: 'transparent',
		borderRadius: token('radius.xsmall'),
		width: '24px',
		height: '24px',
	},
});

export const OptionIcon = ({
	type,
	subType,
	iconPath,
}: {
	type: ConfluenceContentType | 'space';
	subType?: string;
	iconPath?: string;
}): React.JSX.Element | null => {
	if (!!iconPath) {
		return (
			<Inline xcss={styles.spaceIcon}>
				<Image
					src={
						iconPath?.includes('/wiki') || iconPath?.startsWith('http')
							? iconPath
							: `/wiki${iconPath}`
					}
					alt=""
				/>
			</Inline>
		);
	} else {
		if (type === 'page' && subType?.toLowerCase() === 'live') {
			return <LiveDocIcon label="" color={token('color.icon.accent.magenta')} />;
		}
		switch (type) {
			case 'page':
				return <PageIcon label="" color={token('color.icon.accent.blue')} />;
			case 'blogPost':
				return <BlogPostIcon label="" color={token('color.icon.accent.blue')} />;
			case 'whiteboard':
				return <WhiteboardIcon label="" color={token('color.icon.accent.teal')} />;
			case 'database':
				return <DatabaseIcon label="" color={token('color.icon.accent.purple')} />;
			case 'folder':
				return <FolderIcon label="" color={token('color.icon.accent.magenta')} />;
			case 'embed':
				return <EmbedIcon label="" color={token('color.icon.accent.gray')} />;
			default:
				return null;
		}
	}
};
